var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "v-card",
        { attrs: { id: "activityView" } },
        [
          _c(
            "v-card-title",
            [
              _vm._v(" " + _vm._s(_vm.$t("activityfeed.title")) + " "),
              _c("v-spacer"),
              _vm.hasDeletePermissions
                ? _c(
                    "v-btn",
                    {
                      attrs: { color: "red" },
                      on: { click: _vm.showDeleteHistoryConfirm }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("activityfeed.delete-user-history")) +
                          " "
                      )
                    ]
                  )
                : _vm._e(),
              _c(
                "v-btn",
                { attrs: { color: "grey" }, on: { click: _vm.getActivity } },
                [
                  _c("v-icon", { attrs: { disabled: _vm.loading } }, [
                    _vm._v(" mdi-refresh ")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _c("v-data-table", {
                attrs: {
                  filterable: "",
                  headers: _vm.headers,
                  items: _vm.activity,
                  "item-key": "id",
                  loading: _vm.loading,
                  search: _vm.search
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.verb",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c(
                          "v-chip",
                          { class: item.verb },
                          [
                            _c(
                              "v-icon",
                              { staticClass: "mr-2", class: item.verb },
                              [_vm._v(" " + _vm._s(_vm.icon(item)) + " ")]
                            ),
                            _vm._v(" " + _vm._s(item.verb.toUpperCase()) + " ")
                          ],
                          1
                        )
                      ]
                    }
                  },
                  {
                    key: "item.time",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _vm._v(" " + _vm._s(_vm.displayDate(item.time)) + " ")
                      ]
                    }
                  },
                  {
                    key: "item.message",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c(
                          "v-expansion-panels",
                          { attrs: { "no-border": "" } },
                          [
                            _c(
                              "v-expansion-panel",
                              { key: item.id, attrs: { "no-border": "" } },
                              [
                                _c("v-expansion-panel-header", [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(item.message)
                                    }
                                  })
                                ]),
                                _c("v-expansion-panel-content", [
                                  _vm._v(" " + _vm._s(item.meta) + " ")
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { justify: "center" } },
        [
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "500px" },
              model: {
                value: _vm.showDeleteDialog,
                callback: function($$v) {
                  _vm.showDeleteDialog = $$v
                },
                expression: "showDeleteDialog"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", [
                    _vm._v(
                      _vm._s(_vm.$t("activityfeed.delete-users-entire-history"))
                    )
                  ]),
                  _c("v-card-text", [
                    _vm._v(
                      _vm._s(_vm.$t("activityfeed.delete-history-warning"))
                    )
                  ]),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c("v-btn", { on: { click: _vm.cancelDeleteHistory } }, [
                        _vm._v(" " + _vm._s(_vm.$t("global.cancel")) + " ")
                      ]),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "red" },
                          on: { click: _vm.confirmDeleteHistory }
                        },
                        [_vm._v(" Delete! ")]
                      ),
                      _c("v-spacer")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }